import axios from "axios";
const URL = process.env.REACT_APP_MASTER_URL;

export const getFormFields = async (session, params) => {
  //   debugger;
  const paramStr = params?.toString().replaceAll(",", "/");
  console.log("session dsdasdsadasdsa: ", session);
  let url = `${URL}/` + session + "/" + paramStr; // + "/GITL";
  console.log("URL : ", url);
  // let url ='http://localhost:3001/dataentrybysession';
  const response = await axios.get(url);
  console.log("response : ", response);
  // debugger;
  return response.data;
};

export const getResponsiveTableData = async (session, params) => {
  //   debugger;
  console.log("getResponsiveTableData session : ", session,params);
  const paramStr = params?.toString().replaceAll(",", "/");
  let url = `${URL}/enquiry/dynamicform/` + session + "/" + paramStr; // + "/GITL";
  console.log("URL : ", url);
  // let url ='http://localhost:3001/dataentrybysession';
  try {
    const response = await axios.get(url);
    console.log("response.status : ", response.status);
    console.log("response dynamic form table::", response.data.searchdata);
    // debugger;
    return response.data;
  } catch (error) {
    console.log("responseerror : ", error);
    return error
    // if (error.status === 404) {
    //   return "NOT IMPLEMENTED";
    // } else return error;
  }
};

export const addData = async (session, item) => {
  //   debugger;
  console.log("addData session : ", session);
  let url = `${URL}/master/` + session;
  console.log("URL : ", url);
  // let url ='http://localhost:3001/dataentrybysession';
  const response = await axios.post(url, item);
  console.log(" addData response : ", response);
  //   debugger;
  return response.data;
};

export const deleteData = async (session, item) => {
  //   debugger;
  console.log("deleteData session : ", session, "\n item : ", item);
  let url = `${URL}/master/` + session + `delete`;
  console.log("URL : ", url);
  // let url ='http://localhost:3001/dataentrybysession';
  const response = await axios.post(url, item);
  console.log(" deleteData response : ", response);
  //   debugger;
  return response.data;
};
